import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DeclarationsAuthService } from '../auth/declarations-auth.service';
import { Subject, takeUntil } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { omit } from 'lodash-es';

@Component({
  selector: 'ad-landing',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    @if (loggedIn) {
      <div class="d-flex justify-content-center">
        <div class="card m-4" style="width: 400px;">
          <div class="card-body d-flex gap-4 align-items-center justify-content-between">
            <p class="m-0"><i> Loading data...</i></p>
            <i class="bi bi-check-lg text-success"></i>
          </div>
        </div>
      </div>
    }
  `
})
export class LandingComponent implements OnInit {
  private destroy$ = new Subject<void>();
  protected loggedIn = false;
  private hasNavigated = false;

  constructor(
    private declarationsAuthService: DeclarationsAuthService,
    private router: Router,
    private route: ActivatedRoute,
    private logger: NGXLogger
  ) {}

  public ngOnInit(): void {
    this.declarationsAuthService.loggedIn$
      .pipe(takeUntil(this.destroy$))
      .subscribe((loggedIn) => (this.loggedIn = loggedIn));

    if (!this.hasNavigated) {
      this.hasNavigated = true;
      this.logger.log('System is now ready');
      setTimeout(() => {
        const path = this.route.snapshot.queryParamMap.get('origin') || '/home';
        const remainingParams = omit(this.route.snapshot.queryParams, ['origin']);
        this.router.navigate([path], { queryParams: remainingParams });
      }, 250);
    }
  }
}
